export interface StatusTemplate<T> {
  status: boolean;
  data: T;
}

export class TemplateHandler {
  public withStatusTemplate<T>({
    status,
    data,
  }: {
    status: boolean;
    data: T;
  }): StatusTemplate<T> {
    return {
      status,
      data,
    };
  }
}
